import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  TerminationService,
  Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardRequestDto,
} from '../../services/wealthlane-award-services';

const usePostTerminationAdjustAward = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setInitialData: (data: any) => void
): any => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        TerminationService.postApiAwardApiAppTerminationAdjustAwards(payload)
      );
    },
    {
      onSuccess: (response, payload) => {
        if (response) {
          setInitialData({
            ...payload,
            awardDetails: response.map((award) => ({
              ...award,
              employeeId: payload.employeeId,
              terminationDate: payload.terminationDate,
              expirationDate: award.optionExpiration,
            })),
          });
          //   void queryClient.invalidateQueries('postCheckFinchConnection');
          //   toast.success(<ToastComponent label='Success' message='Finch Connected' />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostTerminationAdjustAward;
